export default {
  labels: {
    open: 'Mostrar artículos',
    collapse: 'Cerrar artículos',
    in_stock: 'En stock',
    out_of_stock: 'Sin stock',
    visible: 'Visible en el menú',
    hidden: 'Oculto del menú',
  },
  list: {
    name: 'Artículo del menú',
    price: 'Precio',
    is_available: 'EN STOCK/SIN STOCK',
  },
};
